<div class="d-flex flex-column align-items-center">
    <div class="dialog-header">
        <span
            hamIconShapes
            icon="assets/hamIcons/lock-filled-large.svg"
            [variant]="'red'"
            [size]="'lg'"
            class="no-hover"
        ></span>
        <span class="dialog-header__title" style="margin-top: 16px;">
            {{ 'aumico_annual_report_confirmation_unseal_dialog_title' | i18next }}
        </span>
    </div>
    <div class="dialog-body">
        <span class="dialog-body__text">
            {{ 'aumico_annual_report_confirmation_unseal_dialog_description' | i18next }}
        </span>
        <div class="warning-block">
            <span class="warning-block__text">
                {{ 'aumico_annual_report_unseal_warning' | i18next }}
            </span>
        </div>
    </div>
</div>
